/* @flow */

export const SHOW_MARKET_FILTER_MENU = 'SHOW_MARKET_FILTER_MENU';
export const HIDE_MARKET_FILTER_MENU = 'HIDE_MARKET_FILTER_MENU';

export const SHOW_MARKET_AUTOCOMPLETE = 'SHOW_MARKET_AUTOCOMPLETE';
export const HIDE_MARKET_AUTOCOMPLETE = 'HIDE_MARKET_AUTOCOMPLETE';

export const DISMISS_MARKET_TOPIC_NOT_FOUND = 'DISMISS_MARKET_TOPIC_NOT_FOUND';

export const SET_MARKET_FIRST_TOPIC = 'SET_MARKET_FIRST_TOPIC';
export const RESET_MARKET_FIRST_TOPIC = 'RESET_MARKET_FIRST_TOPIC';

export const FREEZE_MARKET_TOPICS = 'FREEZE_MARKET_TOPICS';
export const UNFREEZE_MARKET_TOPICS = 'UNFREEZE_MARKET_TOPICS';
